export default __webpack_public_path__ + "static/media/Icon52.896f0001.svg";